import { render, staticRenderFns } from "./ed-deny-user-request.component.vue?vue&type=template&id=62049fd1&scoped=true&"
import script from "./ed-deny-user-request.component.ts?vue&type=script&lang=ts&"
export * from "./ed-deny-user-request.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-deny-user-request.component.scss?vue&type=style&index=0&id=62049fd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62049fd1",
  null
  
)

export default component.exports